var render = function render(){var _vm=this,_c=_vm._self._c;return _c('wrapper-page',{attrs:{"ignoreSubscriptionStatus":true}},[_c('add-payment-method')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }